import getStore from 'services/getStore';

const store = getStore();

const values = {
  headerHeight: 70,
};

const colors = {
  lPink: '#ff0063',
  lBlue0: '#b3cde0',
  lGrey0: '#282a2b',
  lGrey1: '#dee3f3',
  lGrey2: '#ecedf0',
  lGrey3: '#eaeffb',
  lGrey4: '#f5f8fa',
  lTeal0: '#3c95a4',
  lTeal1: '#32d0d0',
  //
  mint: '#00D9D3',
  purple: '#9E6CFF',
};

const focusBorder = '1px solid #2684FF !important';
const focusBoxShadow = '0 0 0 1px #2684FF !important';

function getButtonFocus(color, shadowBefore: any = null) {
  const { highContrast = false } = store.getState().theme;

  return !window.dev()
    ? `
    box-shadow: ${
      shadowBefore ? `${shadowBefore}, ` : ''
    }0 0 0 2px #fff, 0 0 0 ${highContrast ? 5 : 3}px ${color} !important;`
    : '';
}

const CALCULATED_LINE_HEIGHT_OFFSET = 1.2;

export {
  values,
  colors,
  focusBorder,
  focusBoxShadow,
  getButtonFocus,
  CALCULATED_LINE_HEIGHT_OFFSET,
};
